import {makeAutoObservable, observable} from 'mobx'
import {Hub} from 'yougile-model'

interface State {
  taskToConnect: Hub | undefined
}

export class TaskConnectionStore {
  state: State

  constructor() {
    this.state = {
      taskToConnect: undefined
    }

    makeAutoObservable(
      this,
      {
        state: observable.shallow
      },
      {autoBind: true}
    )
  }

  setData(task: Hub): void {
    this.state.taskToConnect = task
  }

  clear(): void {
    this.state.taskToConnect = undefined
  }
}

export const taskConnectionStore = new TaskConnectionStore()
